import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card_3.css";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";
import Select_Product_By_Weight_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Weight_Modal";
import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useNavigate } from "react-router-dom";
import Heart_icon from "../heart_icon/Heart_icon";
import { encodeId } from "../../../utils/common";

const Product_Info_Card_3 = ({ product, showQty }) => {
  const [favouriteProduct, setFavouriteProduct] = useState();

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState({});
  const [variant, setVariant] = useState({});

  return (
    <section className="Product_Info_Grid_View_Section Product_Info_Card_3">
      <div className="Product_Info_Grid_View">
        <div
          className="upper_image_section"
         
        >
          <div className="card_img_holder"  onClick={() =>
            navigate(`/product-description/${encodeId(product?.id)}`)
          }>
            <img
              className=""
              src={process.env.REACT_APP_IMG_URL + product?.image}
              alt={product?.name}
            />
          </div>
          {product?.Offered_Product && (
            <div className="text_div">
              <div className="discont_div">
                <p className="discount_text">
                  Upto{" "}
                  {product?.Offered_Product?.Discount_Type?.id === 1
                    ? `₹ ${product?.Offered_Product?.discount}`
                    : `${product?.Offered_Product?.discount}%`}{" "}
                  Off
                </p>
              </div>
            </div>
          )}

          {product?.company && (
            <div class="company_div">
              <p class="company_text">{product?.company}</p>
            </div>
          )}
        </div>

        <div
          className="lower_text_section"
          onClick={() => {
            navigate(`/product-description/${encodeId(product?.id)}`);
          }}
        >
          <p
            className="product_subname"
            onClick={() => {
              navigate(`/product-description/${encodeId(product?.id)}`);
            }}
          >
            {product?.p_sub_category?.name}
          </p>
          <p
            className="product_name"
            onClick={() => {
              navigate(`/product-description/${encodeId(product?.id)}`);
            }}
          >
            {product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="price">
                ₹{Number(product?.Product_Variants[0]?.price).toFixed(2)}{" "}
                <span>/pc</span>
              </p>

              <p className="mrp">
                ₹{Number(product?.Product_Variants[0]?.mrp).toFixed(2)}{" "}
              </p>
            </div>

            {/* {showQty && (
              <div className="kilo_main_div">
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">{product?.Unit?.name}</p>
                  </div>
                  <div>
                    <p className="icon_p">
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            )} */}
          </div>

          {/* <div className="text-center btn_holder">
            {!product?.outofStock ? (
              <>
                {!showIncrement ? (
                  <div className="">
                    <Green_Btn
                      btn_name="Add to Cart"
                      leftIcon={faBasketShopping}
                      onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                      }}
                    />
                  </div>
                ) : (
                  <div className="">
                    <Green_Btn
                      btn_name="Add to Cart"
                      leftIcon={faBasketShopping}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="">
                <Red_Outline_Btn btn_name="Out of Stock" />
              </div>
            )}
          </div> */}

          <Heart_icon product={product} />
        </div>
      </div>
      <Select_Product_By_Weight_Modal
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        product={product}
        show={addcartmodal}
        onHide={() => Setaddcartmodal(false)}
      />

      {/* <Select_Product_By_Weight_Modal
                variants={product?.Product_Variants}
                selectedVariant={selectedVariant}
                setSelectedVariant={setSelectedVariant}
                setVariant={setVariant}
                show={addcartmodal}
                onHide={() => Setaddcartmodal(false)}
            /> */}
    </section>
  );
};

export default Product_Info_Card_3;
